import React, {useEffect, useState} from "react";
import axios from "axios";

const ProfileBasicInfo = () => {
  const [profileData, setProfileData] = useState(null);
  const [fullProfile, setFullProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profileSkills, setProfileSkills] = useState([]);

  const fetchUserData = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}users/searchuser/${userId}`
      );
      setProfileData(response.data[0]);
      localStorage.setItem("username", response.data[0]?.name);
    } catch (error) {
      console.error("Error while searching for user:", error);
    }
  };

  const fetchFullUserData = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}candidate_details/showcandidatebyid/${userId}`
      );
      const profile = response.data;

      const initialValue = Array.isArray(profile.skills) ? profile.skills : profile.skills ? profile.skills?.split(",") : [];
      setProfileSkills(initialValue);
      setFullProfile(response.data);
    } catch (error) {
      console.error("Error finding candidate details:", error);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("jwttoken");
    const userId = localStorage.getItem("userid");
    if (token && userId) {
      Promise.all([fetchUserData(userId), fetchFullUserData(userId)])
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const age = fullProfile?.dob ? calculateAge(fullProfile.dob) : "N/A";

  // if (loading) return <p>Loading...</p>;
  if (!profileData) return <p>No user data found</p>;

  return (
    // <div className="col-lg-9">
    <>
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Profile Basic Info</h4>
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="profile-info-list">
                <ul>
                  <li>
                    Full Name: <span>{profileData.name}</span>
                  </li>
                  <li>
                    Email: <span>{profileData.email}</span>
                  </li>
                  <li>
                    Contact Number: <span>{profileData.mobile}</span>
                  </li>
                  <li>
                    Date Of Birth: <span>{fullProfile?.dob || "N/A"}</span>
                  </li>
                  <li>
                    Degree: <span>{fullProfile?.branch || "N/A"}</span>
                  </li>
                  <li>
                    College: <span>{fullProfile?.college || "N/A"}</span>
                  </li>
                  <li>
                    University: <span>{fullProfile?.university || "N/A"}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="profile-info-list">
                <ul>
                  
                  <li>
                    Language: <span>{fullProfile?.language || "N/A"}</span>
                  </li>
                  
                  <li>
                    Passing Year:{" "}
                    <span>{fullProfile?.passing_year || "N/A"}</span>
                  </li>
                  
                  <li>
                    Experience:{" "}
                    <span>{fullProfile?.yearsOfExperience || "N/A"}</span>
                  </li>
                  <li>
                    Current Company:{" "}
                    <span>{fullProfile?.currentcompany || "N/A"}</span>
                  </li>
                  <li>
                    Current Salary:{" "}
                    <span>{fullProfile?.currentSalary || "N/A"}</span>
                  </li>
                  <li>
                    Current Designation:{" "}
                    <span>{fullProfile?.currentDesignation || "N/A"}</span>
                  </li>
                  <li>
                    Notice Period:{" "}
                    <span>{fullProfile?.noticePeriod || "N/A"}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Skills</h4>
          <div className="col-lg-12">
            <div className="profile-skill">
              {
                profileSkills.map((skill, index) => {
                  return <span
                    key={skill.skill_id}
                    className="badge bg-primary me-2 mb-2 d-inline-flex align-items-center cursor-pointer rounded-3"
                  >
                    <span className="d-flex flex-column p-1">
                     <span>{skill.skill_name}</span>
                    </span>
                    </span>
                })
              }
            </div>
          </div>
        </div>
      </div>
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Bio</h4>
          <div className="col-lg-12">
            <div className="profile-bio">
              {fullProfile?.bio ? (
                <p dangerouslySetInnerHTML={{__html: fullProfile.bio}}></p>
              ) : (
                <p>No bio available</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Contact Info</h4>
          <div className="col-lg-6">
            <div className="profile-info-list">
              <ul>
                <li>
                  Country: <span>{fullProfile?.country_name || "N/A"}</span>
                </li>
                <li>
                  City: <span>{fullProfile?.city_name || "N/A"}</span>
                </li>
                <li>
                  State: <span>{fullProfile?.state_name || "N/A"}</span>
                </li>
                <li>
                  Home Town: <span>{fullProfile?.hometown || "N/A"}</span>
                </li>
                <li>
                  Full Address: <span>{fullProfile?.address || "N/A"}</span>
                </li>
                <li>
                  Postal Code: <span>{fullProfile?.post_code || "N/A"}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="user-profile-wrapper">
        <div className="user-profile-card">
          <h4 className="user-profile-card-title">Social Network</h4>
          <div className="col-lg-6">
            <div className="profile-social">
              <a href={fullProfile?.linkedinid || "#"}>
                <i className="fab fa-linkedin-in"/>
              </a>
              <a href={fullProfile?.githubid || "#"}>
                <i className="fab fa-github"/>
              </a>
              <a href={fullProfile?.whatsapp_mobile ? `https://wa.me/${fullProfile.whatsapp_mobile}` : "#"} target="_blank" rel="noopener noreferrer">
                <i className="fab fa-whatsapp"/>
              </a>
              <a href={fullProfile?.portfolio || "#"} target="_blank" rel="noopener noreferrer">
                <i className="fas fa-briefcase"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    {/* </div> */}
    </>
  );
};

export default ProfileBasicInfo;
